import { Stack } from '@pairy/pds-react';
import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const CloseButton = styled.button`
  min-width: 25px;
`;

export const Modal = styled(Stack)`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.ctaFormLayer};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ModalBody = styled(Stack)`
  padding: 2rem;
  background-color: ${theme.colors.white};
  border-radius: 0.5rem;
`;

export const ModalContents = styled(Stack)`
  overflow: scroll;
  max-height: calc(100vh - 512px);
  overscroll-behavior: contain;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Dim = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.ctaFormDimmer};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(0.5rem);
  background-color: rgb(0 0 0 / 50%);
`;

export const Spinner = styled.div`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  display: flex;
  animation: spin 1s linear infinite;
`;

export const FlexBottomCTAButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
